module.exports = __webpack_public_path__ + "img/8.00ba4100.jpg";